import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppService } from 'src/app/core/services/app.service';
import { OOVenueService } from 'src/app/core/services/venue-service';
import { GenericLabelValue } from 'src/app/shared/models/DTO/GenericLabelValue.dto';
import { OOMenuItem } from 'src/app/shared/models/oo-menu-item';

@Component({
	selector: 'app-menu-item-subscription-setup',
	templateUrl: './menu-item-subscription-setup.component.html',
	styleUrls: ['../../../../commandcenter.scss'],
})
export class MenuItemSubscriptionSetupComponent implements OnInit {
	@Input() menuItemKey: number;
	@Output() unsavedChangesChange = new EventEmitter<boolean>();

	menuItem: OOMenuItem;

	subscriptionFrequencyOptions: GenericLabelValue[];
	constructor(public app: AppService, public venueService: OOVenueService) {}

	ngOnInit(): void {
		this.subscriptionFrequencyOptions = this.venueService.subscriptionFrequencyOptions();
		this.menuItem = this.venueService.ooMenuItems.find((item) => item.menuItemKey === this.menuItemKey);
	}
}
